import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import * as dateFns from 'date-fns';
import { enUS, es, frCA, ja, ko } from 'date-fns/locale';

import { LocaleMap } from '@libs/src/locale/locale-map.interface';

const MINIMUM_DAYS_PAST = 1;
const DATE_DEFAULT_FORMAT = { date: 'mediumDate', time: 'shortTime' };
const localeMap: LocaleMap = {
  es,
  ja,
  ko,
  'en-US': enUS,
  'fr-CA': frCA,
};

@Pipe({
  name: 'appTimeAgo',
})
export class TimeAgoPipe implements PipeTransform {
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private datePipe: DatePipe,
  ) {}

  transform(value: any): any {
    const now = new Date(Date.now());
    return MINIMUM_DAYS_PAST > dateFns.differenceInDays(now, new Date(value))
      ? dateFns.formatDistanceToNow(new Date(value), {
          addSuffix: true,
          locale: (localeMap as any)[this.locale],
        })
      : $localize`:@@timeAgoPipe.defaultTime:${this.datePipe.transform(
          value,
          DATE_DEFAULT_FORMAT.date,
        )} at ${this.datePipe.transform(value, DATE_DEFAULT_FORMAT.time)}`;
  }
}
